import React, { useState } from 'react';
import { Validator } from '@leverege/validator';
import { Flex, Text, TextInput, ToggleButton } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import S from './Methods.css';
const {
  t
} = I18N.ns('login.twoFactor.EmailListItem');
export default function EmailListItem(props) {
  const {
    method,
    user,
    onToggleMethod,
    isEnabled
  } = props;
  const [email, setEmail] = useState(user.email);
  const onChangeEmail = ({
    value
  }) => {
    setEmail(value);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, null, method.name), /*#__PURE__*/React.createElement(Flex, {
    variant: "rowL",
    align: "center"
  }, isEnabled ? /*#__PURE__*/React.createElement(Text, null, user?.twoFactor?.methods?.email?.email) : /*#__PURE__*/React.createElement(TextInput, {
    hint: t('hint'),
    autoComplete: "email",
    className: S.emailInput,
    variant: "formInput",
    value: email,
    changeOnReturn: false,
    onChange: onChangeEmail
  }), /*#__PURE__*/React.createElement(ToggleButton, {
    onChange: onToggleMethod,
    value: isEnabled,
    on: t('on'),
    off: t('off'),
    disabled: !Validator.isEmail(email),
    eventData: {
      method,
      data: {
        email
      }
    }
  })));
}